import { unknown, boolean, object } from "superstruct";

const RewardsStorefrontValuesProgramsStatusSchema = object({
    pointsProgramEnabled: boolean(),
    referralProgramEnabled: boolean(),
    tiersProgramEnabled: boolean(),
    b2bProgramEnabled: unknown(),
});

export default RewardsStorefrontValuesProgramsStatusSchema;
